module.exports = __webpack_public_path__ + "img/pic12.0a90acd.png";